const LIBRARY = {
  SET_BLOCK_QUERY: 'SET_BLOCK_QUERY',
  SET_READER_QUERY: 'SET_READER_QUERY',
  SET_AI_QUERY: 'SET_AI_QUERY',
  SET_EDUCATION_QUERY: 'SET_EDUCATION_QUERY',
};

export default LIBRARY;
